import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MainPage from './pages/main/MainPage';
import PresetPage from './pages/preset/PresetPage';
import PresetListPage from './pages/presetList/PresetListPage';
import { AuthProvider } from './features/authentication';
import { useAuthStore } from './features/authentication';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { appInsightsKey } from './Config';
import { setupFetchLogging, setAzureLogger } from './utils/setupFetchLogging';
import myGif from './assets/throbber.gif';

const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: appInsightsKey,
    loggingLevelConsole: 2,
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
  },
});

const customTelemetryInitializer = (envelope: any) => {
  const telemetryItem = envelope.baseData;
  const authState = useAuthStore.getState();

  telemetryItem.properties = {
    ...telemetryItem.properties, // Preserve existing properties
    userId: authState.userId || '',
    userName: authState.displayName || '',
    userEmail: authState.username || '',
  };
};

appInsights.addTelemetryInitializer(customTelemetryInitializer);

appInsights.loadAppInsights();

setupFetchLogging();
setAzureLogger(appInsights);

window.onerror = (message, source, lineno, colno, error) => {
  appInsights.trackException({
    exception: error || new Error(String(message)),
  });
};

const AppContent = () => {
  const { isLoading, isInitialized, isAuthenticated } = useAuthStore();

  if (!isInitialized || (isAuthenticated && isLoading)) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          color: 'rgba(16, 29, 59, 0.6)',
          gap: '0.8vh',
          fontSize: '1.4vh',
          fontWeight: '400',
        }}
      >
        <img src={myGif} height={'30vh'} width={'30vh'} alt="Loading Animation" />
        Loading...
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/preset/:id" element={<PresetPage id={window.location.pathname.split('/')[2]} />} />
        <Route path="/preset-list" element={<PresetListPage />} />
        <Route path="/:id" element={<MainPage id={window.location.pathname.split('/')[1]} />} />
        <Route path="*" element={<MainPage />} />
      </Routes>
      <ToastContainer />
    </Router>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export { appInsights };

export default withAITracking(reactPlugin, App);
